import * as React from "react";
import { ReportMonitoringDataPropsT } from "../types";
import MainContainer from "./features/MainContainer";

export default ({ data: props }: ReportMonitoringDataPropsT): JSX.Element => {
  const { headerData, reportingId } = props;

  return <MainContainer reportingId={reportingId} headerData={headerData} />;
};
